/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import CONST_PAYMENT from 'constants/payments';

// Styles
import useStyles from './paymentFilter.styles';

const PaymentFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const filteredPayments = useSelector(
    (state: ApplicationState) => state.reports.selectedPayments,
  );

  const handlePayment = (payment: any) => {
    const updated = [...filteredPayments];
    const index = filteredPayments.findIndex((e) => e.key === payment.KEY);

    if (index === -1) updated.push({ key: payment.KEY, value: payment.VALUE });
    else updated.splice(index, 1);

    dispatch(
      ReportActions.setSelectedPayments({
        selectedPayments: updated,
      }),
    );
  };

  return (
    <List dense>
      {CONST_PAYMENT.ENTRY.map((item) => (
        <ListItem key={item.KEY} button>
          <ListItemText
            id={item.KEY}
            primary={item.VALUE}
            onClick={() => handlePayment(item)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              color='primary'
              onChange={() => handlePayment(item)}
              checked={!!filteredPayments.find((e) => e.key === item.KEY)}
              inputProps={{ 'aria-labelledby': item.KEY }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { PaymentFilter };
export default PaymentFilter;
